import RightAction from './RightAction.component';

export default RightAction;